'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SocialOdnoklassniki = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.829 8.666a1.127 1.127 0 0 1 1.41 1.76c-.053.041-1.047.828-2.707 1.166l2.505 2.483a1.127 1.127 0 0 1-1.593 1.595l-2.432-2.368-2.21 2.353a1.124 1.124 0 0 1-1.594.03 1.127 1.127 0 0 1-.029-1.595l2.379-2.485c-1.707-.33-2.743-1.137-2.796-1.18a1.127 1.127 0 0 1 1.41-1.759c.01.008 1.094.822 2.84.823 1.745 0 2.806-.815 2.816-.823M8.067 0a4.146 4.146 0 1 1 0 8.292 4.146 4.146 0 0 1 0-8.292m0 2.432a1.714 1.714 0 1 0 0 3.428 1.714 1.714 0 0 0 0-3.428",
            clipRule: "evenodd"
        })
    }));
});

export { SocialOdnoklassniki, SocialOdnoklassniki as default };
